package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorTextInput
import com.exura.ui.TextStyles
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth

@Composable
internal fun ElementMainNameSection(
    value: String,
    onValueChange: (String) -> Unit,
    mode: PlanCreatorInputMode,
    title: String,
    placeholder: String,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = title,
) {
    PlanCreatorTextInput(
        value = value,
        onValueChange = onValueChange,
        mode = if (enabled) mode else PlanCreatorInputMode.VIEW,
        placeholder = placeholder,
        modifier = Modifier.fillMaxWidth(),
        textStyle = TextStyles.medium16
    )
}
